import { Form, Input, Select } from 'antd'

const { TextArea } = Input

const StepOne = () => {
  const form = Form.useFormInstance()

  const reason = Form.useWatch('reason', form)

  const options = [
    {
      value: '1',
      label: 'Não estou usando o serviço com frequência',
    },
    {
      value: '2',
      label: 'Encontrei outra solução que atende melhor às minhas necessidades',
    },
    {
      value: '3',
      label: 'Tive dificuldades técnicas ou problemas de funcionamento',
    },
    {
      value: '4',
      label: 'Faltam recursos ou funcionalidades que eu gostaria de ter',
    },
    {
      value: '5',
      label: 'Preço da assinatura é muito alto',
    },
    {
      value: '6',
      label: 'Outro motivo (quero explicar melhor)',
    },
  ]

  return (
    <>
      <Form.Item
        name="cancel_reason"
        label="Por que você está cancelando a assinatura?"
        rules={[{ required: true }]}
      >
        <Select
          size="large"
          placeholder="Escolha um motivo"
          options={options}
        />
      </Form.Item>

      {reason === '6' && (
        <Form.Item
          name="another_reason"
          label="Motivo"
          rules={[{ required: true }]}
        >
          <TextArea
            showCount
            placeholder="Nos explique melhor"
            maxLength={150}
            style={{ height: 50, resize: 'none' }}
          />
        </Form.Item>
      )}

      <Form.Item name="feedback" label="Feedback">
        <TextArea
          showCount
          placeholder="Deixe seu feedback"
          maxLength={500}
          style={{ height: 100, resize: 'none' }}
        />
      </Form.Item>
    </>
  )
}

export default StepOne
